var ButtonGroup         = require("./ButtonGroup"),
    Button              = require("./Button"),
    $                   = require("jquery"),
    ol                  = require("openlayers");

var ZoomControl = ButtonGroup.extend({

    options: {
        duration: 190
    },

    /**
     *
     * @param options
     */
    initialize: function(options){
        var that = this,
            incButton,
            disButton,
            decButton;

        that.map = undefined;
        that.view = undefined;

        options || (options = {});

        ZoomControl.__super__.initialize.call(that, options);

        that.getContainer().addClass('omjs-zoom-control');

        that.add(new Button({}));
        that.add(new Button({}));
        that.add(new Button({}));

        incButton = that._buttons[0];
        disButton = that._buttons[1];
        decButton = that._buttons[2];

        disButton.getContainer().addClass('disabled').text("0");

        incButton.on('click', function(){
            that._setZoom.call(that, 1);
        });

        decButton.on('click', function(){
            that._setZoom.call(that, -1);
        });
    },

    /**
     *
     * @param view
     */
    onAdd: function(view) {
        var that = this;
        that.view = view;
        that.map = view.getMap();
        that._buttons[1].getContainer()[0].innerHTML = that.map.getView().getZoom();
        that._checkButtonState();

        that.map.getView().on('change:resolution', function(e) {
            that._checkButtonState();
        });
    },

    /**
     *
     * @private
     */
    _checkButtonState: function() {
        var that = this,
        map_view = that.map.getView();

        map_view.getZoom() >= that.view.options.maxZoom
            ? that._buttons[0].getContainer().addClass('disabled')
            : that._buttons[0].getContainer().removeClass('disabled');

        map_view.getZoom() <= that.view.options.minZoom
            ? that._buttons[2].getContainer().addClass('disabled')
            : that._buttons[2].getContainer().removeClass('disabled');

        if ($.isNumeric(map_view.getZoom())) {
            that._buttons[1].getContainer()[0].innerHTML = parseInt(map_view.getZoom());
        }
    },

    /**
     *
     * @param delta
     */
    _setZoom: function(delta){
        var that = this,
            view,
            currentResolution;

        if (!that.map) {
            return;
        }

        view = that.map.getView();

        if (!view) {
            return;
        }

        currentResolution = view.getResolution();
        if (currentResolution) {
            var newResolution = view.constrainResolution(currentResolution, delta);
            view.animate({
                resolution: newResolution,
                easing: ol.easing.easeOut,
                duration: 190
            });

            that._checkButtonState();
        }
    }
});

module.exports = ZoomControl;


//////////////////
// WEBPACK FOOTER
// ./src/View/Widget/ZoomControl.js
// module id = 202
// module chunks = 0